import {BaseHttpError} from './baseHandling/BaseHttpError'
import {ErrorResponseBody} from '../response/ErrorResponseBody'
import {HttpStatusCode} from '../Constants'

export class HttpError extends BaseHttpError {
    constructor(status: HttpStatusCode, readonly responseBody: ErrorResponseBody) {
        super('HttpError', status, responseBody)
    }
}
